import {
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  Edit,
  FormTab,
  List,
  NumberInput,
  required,
  SearchInput,
  SelectInput,
  TextField,
  TextInput,
} from "react-admin";
import { EMOTION_TYPES } from "../constants/emotions";
import { useCommonLabels } from "../i18n/hooks";
import { HexColorInput } from "../ui/forms/HexColorInput";
import { FormSection } from "../ui/forms/FormSection";
import {
  DescriptionLangFields,
  LevelLabelsLangFields,
  TitleLangFields,
} from "../ui/forms/langFields";
import { LangTabbedForm } from "../ui/forms/LangTabbedForm";

const filters = [<SearchInput key="q" source="q" alwaysOn />];

const PhEmotionTypeForm = () => {
  const c = useCommonLabels();
  return (
    <LangTabbedForm>
      <FormTab label="Общее">
        <FormSection title="Тип эмоции">
          <SelectInput source="TypeKey" label="Тип" choices={EMOTION_TYPES} validate={required()} fullWidth />
          <TextInput source="Emoji" label="Emoji" validate={required()} fullWidth />
          <HexColorInput
            source="Color"
            label="Цвет (#hex)"
            required
            defaultValue="#4A2D7A"
            helperText="Цвет карточки эмоции в приложении"
          />
          <NumberInput source="SortOrder" label="Порядок" defaultValue={0} fullWidth />
          <BooleanInput source="Active" label={c.active} defaultValue />
        </FormSection>
      </FormTab>
      <FormTab label="🇦🇿 AZ">
        <TitleLangFields lang="AZ" titleRequired />
        <DescriptionLangFields lang="AZ" />
        <LevelLabelsLangFields lang="AZ" />
      </FormTab>
      <FormTab label="🇷🇺 RU">
        <TitleLangFields lang="RU" titleRequired />
        <DescriptionLangFields lang="RU" />
        <LevelLabelsLangFields lang="RU" />
      </FormTab>
      <FormTab label="🇬🇧 EN">
        <TitleLangFields lang="EN" titleRequired />
        <DescriptionLangFields lang="EN" />
        <LevelLabelsLangFields lang="EN" />
      </FormTab>
    </LangTabbedForm>
  );
};

export const PhEmotionTypeList = () => {
  const c = useCommonLabels();
  return (
    <List filters={filters} sort={{ field: "SortOrder", order: "DESC" }}>
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="TypeKey" label="Тип" />
        <TextField source="Emoji" label="Emoji" />
        <TextField source="TitleRU" label="Название" />
        <TextField source="Color" label="Цвет" />
        <BooleanField source="Active" label={c.status} />
      </Datagrid>
    </List>
  );
};

export const PhEmotionTypeEdit = () => (
  <Edit mutationMode="pessimistic">
    <PhEmotionTypeForm />
  </Edit>
);

export const PhEmotionTypeCreate = () => (
  <Create>
    <PhEmotionTypeForm />
  </Create>
);
